import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { FilterProvider } from "./components/context/FilterContext";
import { ToastContainer } from "react-toastify";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const client = new QueryClient();
root.render(
  <QueryClientProvider client={client}>
    <FilterProvider>
      <App />
      <ToastContainer />
    </FilterProvider>
  </QueryClientProvider>
);
